/**
 * Copyright (c) 2023 Wizart Animation.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Wizart Animation.
 */

import entityTypes, { relatedContentTypes } from "functions/entityTypes";

const currentFilterName = (entityType) =>
    `{{current_${relatedContentTypes[entityType]}}}`;

export const currentObject = Object.keys(relatedContentTypes).reduce(
    (acc, curr) => {
        acc[curr] = currentFilterName(curr);
        return acc;
    },
    {}
);

export const CURRENT_ASSET = currentObject[entityTypes.ASSETS];
export const CURRENT_EPISODE = currentObject[entityTypes.EPISODES];
export const CURRENT_PROJECT = currentObject[entityTypes.PROJECTS];
export const CURRENT_SCENE = currentObject[entityTypes.SCENES];
export const CURRENT_SERIES = currentObject[entityTypes.SERIES];
export const CURRENT_USER = currentObject[entityTypes.USERS];

export default Object.values(currentObject);
